import React, { useState, useRef, useEffect } from 'react';
import { getItemSession } from './../../../utils';
import Levenshtein from 'fast-levenshtein';
import { fetchSearchAutocomplete } from '../../../services/products-api';
import { useLanguage } from '../../../LanguageContext';


const SearchBarResponsive = (props) => {
  const [busca, setBusca] = useState("");
  const [autoComplete, setAutoComplete] = useState(JSON.parse(sessionStorage.getItem("dataProducts")) ?? []);
  const latestProps = useRef(props);
  const [searchResults, setSearchResults] = useState([]);
  const [items, setItems] = useState([]);
  const [itemsPrev, setItemsPrev] = useState([]);
  const { translations } = useLanguage();
  const [buscaCorrigida, setBuscaCorrigida] = useState('');

  useEffect(() => {
    // Quando o searchTerm muda, encontramos o termo mais próximo
    if (busca.length > 0) {
      const match = buscarMelhorTermo(busca, items);
      setBuscaCorrigida(match ?? '');
      console.log("Palavra/frase mais semelhante:", match ?? '');
    } else {
      setBuscaCorrigida(null);
    }
  }, [busca]);

  const buscarMelhorTermo = (termoBusca, listaProdutos) => {
    if (!termoBusca || !listaProdutos || listaProdutos.length === 0) {
      return null;
    }

    let termoMaisProximo = null;
    let minDistance = Infinity;

    listaProdutos.forEach(produto => {
      const descricaoCompostaProduto = (produto.EAN + ' ' + produto.name + ' ' + produto.CodigoProduto).toLowerCase();

      const palavras = descricaoCompostaProduto.toLowerCase().split(/\s+/).filter(Boolean);
      palavras.forEach(termo => {
        const distance = Levenshtein.get(termoBusca.toLowerCase(), termo.toLowerCase());

        if (distance <= minDistance) {
          minDistance = distance;
          termoMaisProximo = termo;
        }
      });
    });
    const distance = Levenshtein.get(termoBusca.toLowerCase(), termoMaisProximo.toLowerCase());
    if (distance <= 2)
      return termoMaisProximo;
    else
      return termoBusca
  };

  useEffect(() => { latestProps.current = props; });
  let filial = getItemSession('_filialSelecionada') ?? 0;

  useEffect(() => {
    let t = getItemSession('_token');
    if (autoComplete.length === 0) {
      fetchSearchAutocomplete(t).then(result => {
        let produtos = [];
        produtos = result.data?.Data?.Dados || [];

        const itensMap = new Map();
        const prodBaseMap = new Map();
        if (produtos.length > 0) {
          produtos.forEach(Item => {

            if (!itensMap.has(Item.CodigoProduto)) {
              itensMap.set(Item.CodigoProduto, {
                id: Item.idProduto,
                name: Item.Descricao,
                EAN: Item.EAN,
                CodigoProduto: Item.CodigoProduto
              });
            }
          });

          const itensArray = Array.from(itensMap.values());
          sessionStorage.setItem('dataProducts', JSON.stringify(itensArray));
          setAutoComplete(itensArray);
        }
      });
    }
    setItems(autoComplete);
  }, [autoComplete]);

  const handleSearchChange = (e) => {
    const valorBusca = e.target.value;
    setBusca(valorBusca);

    const filteredResults = items.filter((product) =>
      product.name.toLowerCase().includes(valorBusca.toLowerCase()) ||
      product.EAN?.toLowerCase().includes(valorBusca.toLowerCase()) ||
      product.CodigoProduto?.toLowerCase().includes(valorBusca.toLowerCase())
    );

    const itensMap = new Map();
    if (filteredResults.length > 0) {
      filteredResults.forEach(Item => {
        if (!itensMap.has(Item.name)) {
          itensMap.set(Item.name, {
            id: Item.id,
            name: Item.name,
            EAN: Item.EAN,
            CodigoProduto: Item.CodigoProduto
          });
        }
      });
      const baseArray = Array.from(itensMap.values());
      setItemsPrev(baseArray)

    }
    setSearchResults(itemsPrev);
  };

  const handleSelectResult = (result) => {
    setBusca(result.name.trim());
    setSearchResults([]);
    redirectToSearchPage(result.name.trim());
  };

  const redirectToSearchPage = (searchTerm) => {
    const encodedSearchTerm = encodeRFC5987ValueChars(searchTerm);
    window.location.href = '/busca?t=' + encodedSearchTerm;
  };

  function encodeRFC5987ValueChars(str) {
    return encodeURIComponent(str)
      .replace(/['()]/g, escape)
      .replace(/\*/g, '%2A')
      .replace(/%(?:7C|60|5E)/g, unescape);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const termo = busca.trim();
    const termoLower = termo.toLowerCase();

    const pareceCodigo = /[0-9-]/.test(termo);
    const temMatchLocal = autoComplete.some((product) =>
      product.name?.toLowerCase().includes(termoLower) ||
      product.EAN?.toLowerCase().includes(termoLower) ||
      product.CodigoProduto?.toLowerCase().includes(termoLower)
    );

    if (!pareceCodigo && !temMatchLocal && buscaCorrigida) {
      redirectToSearchPage(buscaCorrigida);
    } else {
      redirectToSearchPage(termo);
    }
  };

  return (
    filial > 0 &&
    <form className="header_search" onSubmit={handleSubmit}>
      <fieldset>
        <label htmlFor="search" id="searchlabel" className="input-search search-autocomplete">

          <input
            type="text"
            value={busca}
            onChange={handleSearchChange}
            style={{
              border: "1px solid #C9C9C9",
              borderRadius: "10px",
              width: "100%"
            }}
            placeholder={translations.SearchBar?.Input_Placeholder}

          />

          {searchResults.length > 0 && (
            <ul className="search-results">
              {searchResults.map((result, index) => (
                <li key={index} onClick={() => handleSelectResult(result)}>
                  {result.name}
                </li>
              ))}
            </ul>
          )}
          <span className="fas fa-search icon-submit" onClick={handleSubmit} style={{ cursor: 'pointer' }}></span>
        </label>

      </fieldset>
    </form>
  );
};

export default SearchBarResponsive;